import { render, staticRenderFns } from "./PreviewEventPages.vue?vue&type=template&id=3bbeaf6b&scoped=true&"
import script from "./PreviewEventPages.vue?vue&type=script&lang=js&"
export * from "./PreviewEventPages.vue?vue&type=script&lang=js&"
import style0 from "./PreviewEventPages.vue?vue&type=style&index=0&id=3bbeaf6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbeaf6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VBtn,VCol,VHover,VIcon,VRow,VSelect,VTab,VTabs})
